﻿window.idxPass = 0
window.carInterditFichier = ["#", "&", "%", ":", "/", "*", "?", "<", ">", "|", "+", "\\", "\"", String.fromCharCode(8217), String.fromCharCode(9)]
window.heightBarreTache = 40;
window.HeightButton = 50;
window.HeightEntete = 56;
window.jaugePerteServeur = null;
window.$DivSignaleRestore = null

window.cBdd = function (nomBase, option) {
    var Me = this;

    this._disableInitPara = false //on peut désactiver l'init des para sur la base gestion en cas d'achat/support
    if (typeof option == 'undefined') option = {}
    this.nom_base = nomBase
    //jaugePerteServeur = $("<div/>").appendTo("body").dxCtrlPerteServeur({}).dxCtrlPerteServeur("instance");

    this.schemaBdd = null
    this.utiCourant = null
    this.utiCnx = null
    this.table = null
    this.cColonne = null
    this.isDemo = nomBase.startsWith(parametre.code_appli + "_demo")
    //json de l'utilisateur connecté
    this.utiCourantParaJson = null
    this.utiCourantParaJsonAll = null
    this.theme = ""
    var timeOutSaveParaJson = null
    this.dataMoyenneIndicateur = null
    this.mSaveParaJsonUtilisateur = function (funcOk) {
        if (parametre.uti_is_pwd_gestionnaire) {
            if (typeof funcOk != "undefined") funcOk()
            return;
        }

        window.clearTimeout(timeOutSaveParaJson)
        if (typeof funcOk != "undefined") { mSave() }
        else {
            timeOutSaveParaJson = window.setTimeout(function () { mSave() }, 5000)
        }
        function mSave() {
            mMigreDateToNet(Me.utiCourantParaJson)
            if (parametre.isLocalhost && JSON.stringify(Me.utiCourantParaJson).contains("''''''''")) {
                alert("Erreur, le json uti est pas bon")
                alert(mGetStackTrace());
                debugger;
            }
            Me.mAjaxCall({
                command: "saveuticourantparajson",
                para_json: JSON.stringify(Me.utiCourantParaJson),
                nom_champ_para_json: ((parametre.isMobile) ? "para_json_mobile" : "para_json")
            }, function (data) {
                if (typeof funcOk != "undefined") funcOk()
            });
            mMigreFormatDateFromJsonCalcul(Me.utiCourantParaJson);
        }
    }
    var timeOutSaveParaJsonAll = null
    this.mSaveParaJsonUtilisateurAll = function (funcOk) {
        if (parametre.uti_is_pwd_gestionnaire) {
            if (typeof funcOk != "undefined") funcOk()
            return;
        }

        window.clearTimeout(timeOutSaveParaJsonAll)
        if (typeof funcOk != "undefined") { mSave() }
        else {
            timeOutSaveParaJsonAll = window.setTimeout(function () { mSave() }, 2000)
        }
        function mSave() {
            mMigreDateToNet(Me.utiCourantParaJsonAll)
            if (parametre.isLocalhost && JSON.stringify(Me.utiCourantParaJsonAll).contains("''''''''")) {
                alert("Erreur, le json uti est pas bon")
                alert(mGetStackTrace());
                debugger;
            }
            Me.mAjaxCall({
                command: "saveuticourantparajson",
                para_json: JSON.stringify(Me.utiCourantParaJsonAll),
                nom_champ_para_json: "para_json_all"
            }, function (data) {
                if (typeof funcOk != "undefined") funcOk()
            });
            mMigreFormatDateFromJsonCalcul(Me.utiCourantParaJsonAll);
        }
    }

    this.mGetLstVueUti = function (lstVueUti) {
        if (typeof Me.utiCourantParaJsonAll.lstvue == 'undefined') {
            Me.utiCourantParaJsonAll.lstvue = []
            Me.mGetArray("grid_vue").filter(function (o) {
                return o.type_data == "strcon" &&
                    o.id_grid_vue != 1
            }).filter(function (o) {
                return o.id_grid_vue < 10 ||
                    ((o.id_grid_vue >= 10 && o.id_grid_vue <= 13) && Me.objCptCli.objetMetier.hasAdhesion()) ||
                    o.id_grid_vue > 13
            }).sort(function (o1, o2) {
                return o1.id_grid_vue - o2.id_grid_vue
            }).forEach(function (itemData, idx) {
                Me.utiCourantParaJsonAll.lstvue.push({
                    id_grid_vue: itemData.id_grid_vue,
                    tri: idx,
                    visible: (itemData.id_grid_vue == 2 || itemData.id_grid_vue == 3 || itemData.id_grid_vue == 5 || itemData.id_grid_vue == 9 || itemData.id_grid_vue == 10)
                })
            })
        }
        if (typeof lstVueUti != 'undefined') {
            Me.utiCourantParaJsonAll.lstvue = lstVueUti
            Me.mSaveParaJsonUtilisateurAll();
        } else {
            var newLstVue = Me.utiCourantParaJsonAll.lstvue.filter(function (o) {
                return o.id_grid_vue < 10 ||
                    ((o.id_grid_vue >= 10 && o.id_grid_vue <= 13) && Me.objCptCli.objetMetier.hasAdhesion()) ||
                    o.id_grid_vue > 13
            })
            if (Me.utiCourantParaJsonAll.lstvue.length != newLstVue.length) {
                Me.utiCourantParaJsonAll.lstvue = newLstVue
                Me.mSaveParaJsonUtilisateurAll();
            }
        }
        return Me.utiCourantParaJsonAll.lstvue
    }
    this.mAddVueUti = function (idGridVue, index) {
        var dataUti = Me.utiCourantParaJsonAll.lstvue.filter(function (o) {
            return o.id_grid_vue == idGridVue
        })[0]
        if (typeof index == 'undefined') {
            //on rajoute à la fin
            index = 0
            Me.utiCourantParaJsonAll.lstvue.forEach(function (o) {
                if (o.tri > index) index = o.tri
            })
            index += 1
        }
        if (typeof dataUti == 'undefined') {
            dataUti = {
                id_grid_vue: idGridVue,
                tri: index,
                visible: true
            }
            Me.utiCourantParaJsonAll.lstvue.push(dataUti)
        }
        dataUti.tri = index
        dataUti.visible = true
        Me.mSaveParaJsonUtilisateurAll();
    }
    this.mRemoveVueUti = function (idGridVue) {
        var dataUti = Me.utiCourantParaJsonAll.lstvue.filter(function (o) {
            return o.id_grid_vue == idGridVue
        })[0]
        if (typeof dataUti != 'undefined') {
            dataUti.visible = false
        }
        Me.mSaveParaJsonUtilisateurAll();
    }

    this.mGetDataSocieteDefaut = function () {
        if (Me.utiCourantParaJson.idSocieteDefaut == 'undefined' || Me.utiCourantParaJson.idSocieteDefaut == null) {
            var dataSoc = Me.mGetArray("societe").filter(function (o) { return o.date_abandon == null })[0]
            if (typeof dataSoc != 'undefined') Me.utiCourantParaJson.idSocieteDefaut = dataSoc.id_societe
        }
        var dataSociete = Me.mGetArray("societe").filter(function (o) { return o.id_societe == Me.utiCourantParaJson.idSocieteDefaut && o.date_abandon == null })[0]
        if (typeof dataSociete == 'undefined') {
            var dataSociete = Me.mGetArray("societe").filter(function (o) { return o.date_abandon == null })[0]
            if (typeof dataSociete == 'undefined') { return null }
            else { return dataSociete }
        } else { return dataSociete }
    }
    this.mSetIdSocieteDefaut = function (idSociete) {
        Me.utiCourantParaJson.idSocieteDefaut = idSociete
        Me.mSaveParaJsonUtilisateur()
    }
    this.mConfirmValidationFacture = function (target, docCptDetail, funcOk) {
        if (Me.objCptCli.data.multi_societe == "1" && docCptDetail.docCpt.id_type_com == 3 && Me.mGetArray("societe").filter(function (o) { return o.date_abandon == null }).length > 1) {
            var tt = $("<div/>").appendTo("body").dxCtrlTooltip({
                target: target,
                width: 300,
                contentTemplate: function (contentElement) {
                    contentElement.css("padding", "30px")
                    $("<div>Vous allez valider votre facture</div>").appendTo(contentElement)
                    $("<div>sur la société</div>").appendTo(contentElement)
                    var dataSoc = Me.mGetArray("societe").filter(function (o) { return o.id_societe == docCptDetail.docCpt.id_societe })[0]
                    $("<div style='font-size:180%;font-weight:bold;padding:10px 0'>" + dataSoc.nom + "</div>").appendTo(contentElement)
                    $("<div style='margin-top:10px;'/>").appendTo(contentElement).dxCtrlButton({
                        text: "Confirmer",
                        onClick: function (e) {
                            tt.hide()
                            funcOk()
                        }
                    })
                }
            }).dxCtrlTooltip("instance")
            tt.show()
        } else {
            funcOk()
        }
    }

    this.mDemandeBaseImport = function () {
        if (Me.objCptCli.data.acces_base_import == "1") {
            $("<div/>").appendTo("body").dxCtrlImportBaseImportation({
                bddCtrl: Me
            }).dxCtrlImportBaseImportation("instance")
        } else {
            if (Me.objCptCli.data.offre_essai == "1" || Me.isDemo) {
                window.setTimeout(function () {
                    if (Me.isDemo) {
                        mNotify("Vous êtes dans un environnement de démonstration. Vous devez être abonner pour pouvoir importer la <span style='font-family:bangers;font-size:180%'>" + Me.baseAppli.para.libelle_base_import + "</span>", "error", 12000)
                    } else {
                        mNotify("Vous êtes en période d'essai. Vous devez être abonner pour pouvoir importer la <span style='font-family:bangers;font-size:180%'>" + Me.baseAppli.para.libelle_base_import + "</span>", "error", 12000)
                    }
                }, 1000)
            }
            //if (Me.objCptCli.data.offre_essai == "1") {
            //    mNotify("Vous êtes en période d'essai. Vous devez être abonner pour pouvoir importer la <span style='font-family:bangers;font-size:180%'>" + Me.baseAppli.para.libelle_base_import + "</span> &bull; <a>Y aller</a>", "warning", 6000, function () {
            //        $("<div/>").appendTo("body").dxCtrlAchatPopup({
            //            bddCtrl: Me,
            //            idSelectedOnglet: 1
            //        })
            //    })
            //} else {
            $("<div/>").appendTo("body").dxCtrlAchatPopup({
                bddCtrl: Me,
                typeProduit: "import_base",
                onPaiement: function () {
                    Me.objCptCli.data.acces_base_import = "1"
                    Me.objCptCli.mSaveChamp("acces_base_import")
                    $("<div/>").appendTo("body").dxCtrlImportBaseImportation({
                        bddCtrl: Me
                    }).dxCtrlImportBaseImportation("instance")
                    //jaugeDemarrage.mShow()
                    //window.setTimeout(function () {
                    //    forcerFermetureNavigateur = true
                    //    window.location.reload()
                    //}, 1000)
                }
            })
            //}
        }
    }

    this.paraAppli = null
    //this.gestionRappel = null
    this.msgEmailSms = null
    this.baseAppli = null

    this.lstListeNoire = {}
    //this.lstIdStrCon = []

    this.isInit = false
    this.mInit = function (funcOk) {

        // Me.mAjaxCall({ command: "getmoyennestat" }, function (data) {
        //     Me.dataMoyenneIndicateur = data.moyenne_indicateur
        //})
        Me.mAjaxCall({ command: "getdatatablestart" }, function (data) {
            Me.mInitWithData(data, funcOk)
        }, function (data) { },
            function (data, x, y, z) {
            })
    }
    this.mInitWithData = function (data, funcOk) {
        //if (parametre.code_appli == "invi") Me.paraInvitto = new cParaInvitto(Me)
        if (parametre.code_appli == "cog") {
            Me.nomBaseClientForCognoss = lireCookie('nom_base');
        }

        Me.dataMoyenneIndicateur = data.moyenne_indicateur
        Me.gestion_taille_base = data.gestion_taille_base
        Me.lstChampIa = JSON.parse(data.init_data_demarrage.lst_champ_ia)
        Me.utiCourantParaJson = data.init_data_demarrage.para_json_uti
        if (parametre.isMobile) Me.utiCourantParaJson = data.init_data_demarrage.para_json_uti_mobile
        if (Me.utiCourantParaJson.length == 0) Me.utiCourantParaJson = "{}"
        Me.utiCourantParaJson = JSON.parse(Me.utiCourantParaJson)
        mMigreFormatDateFromJsonCalcul(Me.utiCourantParaJson);

        Me.utiCourantParaJsonAll = data.init_data_demarrage.para_json_uti_all
        if (Me.utiCourantParaJsonAll.length == 0) Me.utiCourantParaJsonAll = "{}"
        Me.utiCourantParaJsonAll = JSON.parse(Me.utiCourantParaJsonAll)
        mMigreFormatDateFromJsonCalcul(Me.utiCourantParaJsonAll);

        Me.baseAppli = parametre.lst_appli_all.filter(function (o) { return o.code_appli == parametre.code_appli })[0]

        Me.lstDroitAcces = ((typeof data.init_data_demarrage.lst_droit_acces == 'undefined') ? [] : data.init_data_demarrage.lst_droit_acces)
        Me.lstDroitAccesUtilisateur = ((typeof data.init_data_demarrage.lst_utilisateur_droit_acces == 'undefined') ? [] : data.init_data_demarrage.lst_utilisateur_droit_acces)

        Me.objCptCli = Me.getObjet("compte_client", data.init_data_demarrage.id_compte_client)
        Me.table = new cTable(Me)
        Me.cColonne = new cColonne(Me.vue_colonne)
        Me.paraAppli = new cParaAppli(Me, ((data.paraappli.xml == null) ? {} : data.paraappli.xml))
        //Me.paraAppli.mGetLstModuleAndLstKey() //init des paramètres
        if (!Me._disableInitPara) Me.paraAppli.mInitPara() //init des paramètres
        //on init l'utilisateur courant dans la base
        Me.utiCourant = Me.mGetArray("utilisateur").filter(function (uti) { return uti.id_utilisateur == Me.utiCourant.id_utilisateur })[0]
        Me.isInit = true
        //Me.lstIdStrCon = data.lstidstrcon
        Me.theme = Me.utiCourant.theme
        if (parametre.isMobile && Me.theme.endsWith(".compact")) Me.theme = Me.theme.replace(".compact", "")

        //if (typeof option.allowRappel != 'undefined' && option.allowRappel && Me.objCptCli.objetMetier.hasAgenda()) {
        //    Me.gestionRappel = new cRappel(Me)
        //}
        if (typeof option.allowMsgEmail != 'undefined' && option.allowMsgEmail) {
            Me.msgEmailSms = new cMsgEmailSms(Me)
        }

        //if (!Me.isExterne()) Me.mUpdateListeNoire()
        Me.mUpdateListeNoire()

        Me.repertoireRacine = "~/fichier/" + Me.nom_base
        Me.repertoireRacineDocumentPartage = "~/fichier/" + Me.nom_base + "/documents_partages"
        Me.repertoireRacineDocumentPartage = "~/fichier/" + Me.nom_base + "/documents_partages"
        Me.repertoireRacineDocumentPublic = "~/fichier/" + Me.nom_base + "/documents_publics"
        Me.repertoireCorbeille = "~/fichier/" + Me.nom_base + "/corbeille"
        Me.repertoireBrouillon = "~/fichier/" + Me.nom_base + "/utidoc/" + ((Me.utiCourant) ? Me.utiCourant.id_utilisateur : "0") + "/vos documents"
        Me.repertoireTemporaire = "~/fichier/" + Me.nom_base + "/bdd/temp"
        Me.repertoireFichierTable = "~/fichier/n" + Me.nom_base + "/bdd/fichier_table"
        Me.repertoireImageTable = "~/fichier/" + Me.nom_base + "/img"


        if (typeof Me.utiCourantParaJson.parametre_general == 'undefined') Me.utiCourantParaJson.parametre_general = {}
        if (typeof Me.utiCourantParaJson.parametre_general.son_on == 'undefined') Me.utiCourantParaJson.parametre_general.son_on = true
        //if (typeof Me.utiCourantParaJson.parametre_general.fiche_contact_simplifie == 'undefined') Me.utiCourantParaJson.parametre_general.fiche_contact_simplifie = true
        //Me.utiCourantParaJson.parametre_general.fiche_contact_simplifie = true

        if (typeof option.allowGeocode != 'undefined' && option.allowGeocode) mIntPositionUser()

        funcOk(Me)
    }

    this.mIsAutoriser = function (type) {
        var droit = null
        switch (type) {
            case "export":
                droit = Me.lstDroitAccesUtilisateur.filter(function (o) { return o.id_droit_acces == 1 })[0]
                break;
            case "import":
                droit = Me.lstDroitAccesUtilisateur.filter(function (o) { return o.id_droit_acces == 2 })[0]
                break;
        }
        return (typeof droit == 'undefined' || droit.valeur == "1")
    }

    this.positionUser = null
    function mIntPositionUser() {
        if (Me.positionUser == null) {
            var societe = Me.mGetArray("societe")[0]
            if (typeof societe != 'undefined' && societe.geo_latitude != null) {
                Me.positionUser = {
                    latitude: parseFloat(societe.geo_latitude),
                    longitude: parseFloat(societe.geo_longitude)
                }
            } else if (Me.objCptCli.data.latitude != null) {
                Me.positionUser = {
                    latitude: parseFloat(Me.objCptCli.data.latitude),
                    longitude: parseFloat(Me.objCptCli.data.longitude)
                }
            } else {
                Me.positionUser = {
                    latitude: 48.862221692783834,
                    longitude: 2.349436690484968
                }
            }

            if (navigator.geolocation) {
                var geoOpt = {
                    timeout: 3000,
                    maximumAge: 30
                }
                navigator.geolocation.getCurrentPosition(geoSucc, geoErr, geoOpt);

                function geoSucc(position) {
                    Me.positionUser = {
                        latitude: position.coords.latitude,
                        longitude: position.coords.longitude
                    }
                }
                function geoErr(error) {
                    //var societe = Me.mGetArray("societe")[0]
                    //if (typeof societe != 'undefined' && societe.geo_latitude != null) {
                    //    Me.positionUser = {
                    //        latitude: parseFloat(societe.geo_latitude),
                    //        longitude: parseFloat(societe.geo_longitude)
                    //    }
                    //} else if (Me.objCptCli.data.latitude != null) {
                    //    Me.positionUser = {
                    //        latitude: parseFloat(Me.objCptCli.data.latitude),
                    //        longitude: parseFloat(Me.objCptCli.data.longitude)
                    //    }
                    //} else {
                    //    Me.positionUser = {
                    //        latitude: 48.862221692783834,
                    //        longitude: 2.349436690484968
                    //    }
                    //}
                }
            }
        }
    }

    this.mUpdateListeNoire = function () {
        Me.mAjaxCall({ command: "getlistenoire" }, function (data) {
            var newListeNoire = {}
            if (data.liste_noire_tel != null) {
                if (typeof data.liste_noire_tel.t == 'undefined') data.liste_noire_tel.t = []
                data.liste_noire_tel.t.forEach(function (o) { newListeNoire[o] = 1 })
            }
            if (data.liste_noire_email != null) {
                if (typeof data.liste_noire_email.e == 'undefined') data.liste_noire_email.e = []
                data.liste_noire_email.e.forEach(function (o) { newListeNoire[o] = 1 })
            }

            Me.lstListeNoire = newListeNoire
        })
    }

    var storeData = {}
    this.mGetArray = function (nomTable) {
        var result = null
        if (storeData[nomTable]) { result = storeData[nomTable].array } else { result = null; }
        return result
    }
    this.mGetStore = function (nomTable) { if (storeData[nomTable]) { return storeData[nomTable] } else { return null; } }

    this.hasStore = function (nomTable) {
        return (storeData[nomTable] ? true : false)
    }

    this.mAddOrMajData = function (bddUpdate) {
        if (typeof bddUpdate != 'undefined') {
            for (var prop in bddUpdate) {
                if (typeof bddUpdate[prop] != null) {
                    bddUpdate[prop].forEach(function (data) {
                        var obj = Me.getObjet(data)
                        var nomTable = obj.mGetTable().nom
                        var nomCle = obj.nomCle
                        var id = obj.cle()
                        if (Me.mGetArray(nomTable) == null) {
                            //la table n'existe pas en local
                            //cas handlerext par exemple
                        } else {
                            Me.mGetStore(nomTable).mAddOrMajData(data)
                            //if (Me.mGetArray(nomTable).filter(function (o) { return o[nomCle] == id }).length > 0) {
                            //    //existe déjà
                            //    Me.mMajItemData(prop, data)
                            //} else {
                            //    //existe pas
                            //    Me.mAddItemData(prop, data)
                            //}
                        }
                    })
                }
            }
        }
    }
    this.mAddData = function (bddAdd) {
        for (nomTable in bddAdd) {
            if (typeof bddAdd[nomTable] != null && Me.mGetStore(nomTable)) {
                bddAdd[nomTable].forEach(function (data) {
                    Me.mGetStore(nomTable).insert(data)
                    //Me.mAddItemData(prop, data)
                })
            }
        }
    }
    this.mRemoveData = function (bddRemove) {
        for (nomTable in bddRemove) {
            if (typeof bddRemove[nomTable] != null && Me.mGetStore(nomTable)) {
                nomTable[prop].forEach(function (id) {
                    Me.mGetStore(nomTable).remove(id)
                    //Me.mDelItemData(prop, id)
                })
            }
        }
    }
    this.mMajData = function (bddMaj) {
        for (nomTable in bddMaj) {
            if (typeof bddMaj[nomTable] != null && Me.mGetStore(nomTable)) {
                bddMaj[nomTable].forEach(function (data) {
                    Me.mGetStore(nomTable).update(data["id_" + nomTable], data)
                    //var store = storeData[prop]
                    //var key = store.key()
                    //var dataInit = Me.mGetArray(prop).filter(function (o) { return o[key] == data[key] })[0]
                    //if (typeof dataInit != "undefined") for (ch in data) dataInit[ch] = data[ch]
                })
            }
        }
    }

    //var timeOutModifMajTable = null;
    this.mMaj = function (bddData, idUtiCourant) {
        if (typeof bddData != 'undefined' && bddData != null && typeof bddData.structure != 'undefined') {
            for (var nomTable in bddData.structure) {
                var structureTable = bddData.structure[nomTable]
                bddData[nomTable].forEach(function (itemRow) {
                    for (var nomChampCode in structureTable) {
                        itemRow[structureTable[nomChampCode]] = itemRow[nomChampCode]
                        delete itemRow[nomChampCode]
                    }
                });
            }
        }
        if (typeof bddData == 'undefined') return;
        //var lstFunc = []
        for (var prop in bddData) {
            if (prop != "structure") {
                if (!this.mGetArray(prop)) {
                    //la table n'a pas été encore créé
                    mCreateStore(prop, bddData[prop]);
                }
                else {
                    //la table existe déjà, on met à jour le store
                    mMajStore(prop, bddData[prop]);
                }
            }
        }

        //mClearPersistance()
        for (var prop in bddData) {
            if (prop != "structure") {
                this.triggerFunctionOnModifiedStore(prop, 100)
            }
        }
        this.triggerFunctionOnModifiedBdd(100)
    }

    var datMajSystem = null
    var dateLoadStore = {}
    function mCreateStore(nomTable, data) {
        dateLoadStore[nomTable] = new Date()
        storeData[nomTable] = new cStore(nomTable, data, function () {
            idxPass += 1
            datMajSystem = null
            Me.triggerFunctionOnModifiedStore(nomTable, 100);
            Me.triggerFunctionOnModifiedBdd(100)
        })
        //storeData[nomTable] = new DevExpress.data.ArrayStore({
        //    key: "id_" + nomTable,
        //    data: data,
        //    onModified: function () {
        //        idxPass += 1
        //        datMajSystem = null
        //        Me.triggerFunctionOnModifiedStore(nomTable, 100);
        //        Me.triggerFunctionOnModifiedBdd(100)
        //    }
        //})
    }

    this.triggerFunctionOnModifiedBdd = function (tempo) {
        if (funcOnModifiedBdd.lstFunc.length > 0) mExecuteListOfFunction(funcOnModifiedBdd, tempo)
    }

    this.triggerFunctionOnModifiedStore = function (nomTable, tempo) {
        if (typeof funcOnModifiedTable[nomTable] != 'undefined') {
            if (funcOnModifiedTable[nomTable].lstFunc.length > 0) mExecuteListOfFunction(funcOnModifiedTable[nomTable], tempo)
        }
    }
    this.funcUpdatePersistance = null
    this.triggerFunctionOnModifiedItemData = function (nomTableAction, action, itemData, nomChamp, tempo) {
        if (Me.funcUpdatePersistance != null) Me.funcUpdatePersistance(nomTableAction, itemData)
        if (typeof funcOnModifiedItemData[nomTableAction] != 'undefined') {
            if (funcOnModifiedItemData[nomTableAction].lstFunc.length > 0) mExecuteListOfFunction(funcOnModifiedItemData[nomTableAction], tempo, action, itemData, nomChamp)
        }
    }
    this.triggerFunctionOnModifiedItemDataWithoutTempo = function (lstAction) {
        lstAction.forEach(function (action) {
            if (typeof funcOnModifiedItemData[action.nomTableAction] != 'undefined') {
                if (funcOnModifiedItemData[action.nomTableAction].lstFunc.length > 0) {
                    console.log(action.nomTableAction + "/" + action.action + "/" + action.itemData + "/" + action.nomChamp)
                    funcOnModifiedItemData[action.nomTableAction].lstFunc.forEach(function (func) {
                        func.func(action.action, action.itemData, action.nomChamp)
                    })
                }
            }
        })
    }
    this.triggerFunctionOnModifiedItemDataWithTempo = function (lstAction, tempo) {
        window.setTimeout(function () {
            lstAction.forEach(function (action) {
                if (typeof funcOnModifiedItemData[action.nomTableAction] != 'undefined') {
                    if (funcOnModifiedItemData[action.nomTableAction].lstFunc.length > 0) {
                        console.log(action.nomTableAction + "/" + action.action + "/" + action.itemData + "/" + action.nomChamp)
                        funcOnModifiedItemData[action.nomTableAction].lstFunc.forEach(function (func) {
                            func.func(action.action, action.itemData, action.nomChamp)
                        })
                    }
                }
            })
        }, ((typeof tempo == 'undefined') ? 0 : tempo))
    }

    //rajout de fonction sur la modification de store
    var funcOnModifiedTable = {}
    this.mAddFunctionOnModifiedStore = function (nomTable, container, func, nomFunc) {
        if (!Array.isArray(nomTable)) nomTable = [nomTable]
        nomTable.forEach(function (nomTab) {
            if (typeof funcOnModifiedTable[nomTab] == 'undefined') funcOnModifiedTable[nomTab] = {
                nom: "Modif table " + nomTab,
                timeOutModifGeneral: null,
                timeOutModifExeFunc: null,
                lstFunc: []
            };
            var newFuncOnModified = function () {
                if (container && container.closest("body").length == 0) {
                    return false;
                }
                else { func(); return true; }
            }
            funcOnModifiedTable[nomTab].lstFunc.push({
                nom: nomFunc,
                func: newFuncOnModified
            });
        })
    }

    var funcOnModifiedBdd = {
        nom: "modif BDD",
        lstFunc: [],
        timeOutModifGeneral: null,
        timeOutModifExeFunc: null
    }
    this.mAddFunctionOnModifiedBdd = function (container, func, nomFunc) {
        var newFuncOnModified = function () {
            if (container && container.closest("body").length == 0) {
                return false;
            }
            else { func(); return true; }
        }
        var result = {
            nom: nomFunc,
            func: newFuncOnModified
        }
        funcOnModifiedBdd.lstFunc.push(result);
        return result
    }

    var funcOnModifiedItemData = {}
    this.mAddFunctionOnModifiedItemData = function (nomTable, container, func, nomFunc) {
        if (nomTable == null) {
            nomTable = []
            Me.vue_table.forEach(function (table) {
                if (table.is_displayed_in_corbeille == "1") nomTable.push(table.nom)
            })
        }
        if (!Array.isArray(nomTable)) nomTable = [nomTable]
        nomTable.forEach(function (nomTab) {
            if (typeof funcOnModifiedItemData[nomTab] == 'undefined') funcOnModifiedItemData[nomTab] = {
                nom: "modif ITEMDATA " + nomTab,
                timeOutModifGeneral: null,
                timeOutModifExeFunc: null,
                lstFunc: []
            };
            var newFuncOnModified = function (action, itemData, nomChamp) {
                if (container != null && container.closest("body").length == 0) {
                    return false;
                }
                else { func(action, itemData, nomChamp); return true; }
            }
            funcOnModifiedItemData[nomTab].lstFunc.push({
                nom: nomFunc,
                func: newFuncOnModified
            });
        })

    }

    function mMajStore(nomTable, serverData) {
        if (storeData[nomTable]) {
            storeData[nomTable].sync(serverData)
        }
    }

    this.mClearAndAdd = function (nomTable, lstItemData) {
        var store = storeData[nomTable]
        if (typeof store != 'undefined') {
            store.clearAndAdd(lstItemData)
            //lstItemData.forEach(function (itemData) { store.insert(itemData); })
        }
    }
    this.mAddItemData = function (nomTable, itemData) {
        var store = storeData[nomTable]
        if (typeof store != 'undefined') store.insert(itemData); // store.push([{ type: "insert", data: itemData }])
    }
    this.mMajItemData = function (nomTable, itemData) {
        var store = storeData[nomTable]
        if (typeof store != 'undefined') store.update(itemData[store.key], itemData); // store.push([{ type: "update", data: itemData, key: itemData[store.key()] }])
    }
    this.mDelItemData = function (nomTable, itemData) {
        var store = storeData[nomTable]
        if (typeof store != 'undefined') {
            store.remove(itemData["id_" + nomTable])
        }
    }
    this.mDelItemDataWithId = function (nomTable, id) {
        var store = storeData[nomTable]
        if (typeof store != 'undefined') {
            store.remove(id)
        }
    }

    var lstObjet = []
    this.getObjet = function (data, id, idHistoSupp) {
        if (typeof data !== 'string' && (typeof data.id_fichier != 'undefined' || data.id_table == "0")) {
            //on est sur un fichier
            if (typeof data.id_fichier != 'undefined') { return new cObjetFile(data, Me) }
            else { return new cObjetFile({ id_fichier: data.id }, Me) }
        } else {
            if ((typeof data === 'string' || data instanceof String) && !data.isNumeric() && typeof id != 'undefined' && id != null) {
                //on a un id_table
                var objetDat = lstObjet.filter(function (o) { return o.obj.mGetTable().nom == data && o.obj.cle() == id })[0]
                if (typeof objetDat != 'undefined') {
                    if (diffdate(objetDat.dat, new Date(), "s") < 5) {
                        return objetDat.obj
                    } else {
                        lstObjet.splice(lstObjet.indexOf(objetDat), 1)
                        if (data == "structures") console.log("getstr:" + data + "/" + id)
                        var obj = new cObjet(data, id, this, idHistoSupp)
                        lstObjet.push({ obj: obj, dat: new Date() })
                        return obj
                    }
                } else {
                    if (data == "structures") console.log("getstr:" + data + "/" + id)
                    var obj = new cObjet(data, id, this, idHistoSupp)
                    lstObjet.push({ obj: obj, dat: new Date() })
                    return obj
                }
            } else {
                var obj = new cObjet(data, id, this, idHistoSupp)
                return obj
            }
        }
    }
    this.getObjetAsync = function (nomTable, id, funcOk) {
        if (typeof data.id_fichier != 'undefined' || data.id_table == "0") {
            //on est sur un fichier
            if (typeof data.id_fichier != 'undefined') { funcOk(new cObjetFile(data, Me)) }
            else { funcOk(new cObjetFile({ id_fichier: data.id }, Me)) }
        } else {
            (new cObjet(nomTable)).mGetData(id, true, function (data) {
                funcOk(new cObjet(data))
            })
        }
    }
    this.getObjetDataShow = function (nomTable, id, option) {
        var obj = new cObjet(nomTable, id, this);
        obj.mShowPopup(option)
    }
    this.getObjetData = function (nomTable, id, funcOk) {
        var obj = new cObjet(nomTable, null, this)
        if (nomTable == 'fichier' && !id.isNumeric()) {
            funcOk({
                id_fichier: null,
                path: id.substring(0, id.lastIndexOf("/")),
                nom: id.substring(id.lastIndexOf("/") + 1)
            }, this);
        }
        else { obj.mGetData(id, function (itemData) { funcOk(itemData) }) }
    }

    this.restore = function (idHistorique, funcOk, funcKo, silencieux) {
        if (typeof silencieux == 'undefined') silencieux = false
        Me.mAjaxCall({ command: 'restorefromhistorique', id_historique: idHistorique },
            function (data) {
                var nomTable = Me.table.mGetItem(data.id_table).nom
                if (Me.mGetArray(nomTable) == null) {
                    Me.triggerFunctionOnModifiedItemData(nomTable, "new", dataObjet)
                    if (!silencieux) {
                        mSignaleRestore(nomTable, data.id)
                    }
                    if (typeof funcOk != 'undefined' && funcOk != null) funcOk(nomTable)
                } else {
                    var dataObjet = Me.mGetArray(nomTable).filterFirst(function (o) { return o["id_" + nomTable] == data.id })[0]
                    if (typeof dataObjet != 'undefined') {
                        var dat = new Date()
                        Me.triggerFunctionOnModifiedItemData(nomTable, "new", dataObjet)
                        var dd = diffdate(dat, new Date(), "ms")
                        console.log("restorefromhistorique trigger: " + dd + "ms")
                        if (!silencieux) {
                            mSignaleRestore(nomTable, data.id)
                        }
                        if (typeof funcOk != 'undefined' && funcOk != null) funcOk(nomTable, dataObjet)
                    } else {
                        if (!silencieux) { mNotify("Impossible de restaurer l'élément", "warning", 6000); }
                    }
                }
            }, null, funcKo)

        function mSignaleRestore(nomTable, id) {
            if ($DivSignaleRestore) $DivSignaleRestore.hide()
            $DivSignaleRestore = notify.mShow({
                width: 320,
                showTitle: false,
                message: function (contentElement, popup) {
                    contentElement.closest(".popupcontent").css("padding", "10px")
                    contentElement.css("font-size", "100%")
                    contentElement.css("padding-left", "10px")
                    var $Table = $("<table style='width:100%'/>").appendTo(contentElement)
                    var $Tr = $("<tr/>").appendTo($Table)
                    var $TdMessage = $("<td style='white-space:nowrap;padding-right:5px;text-align:right;'>L'objet a été restauré</td>").appendTo($Tr)
                    var $Td = $("<td style='width:1px;'/>").appendTo($Tr)

                    switch (nomTable) {
                        case "filtre": break;
                        default:
                            $("<div/>").appendTo($Td).dxCtrlButton({
                                icon: "fas fa-eye",
                                txtTooltip: "Ouvrir l'élément",
                                width: 40,
                                onClick: function (e) { Me.getObjet(nomTable, id).mShowPopup(); }
                            })
                            break;
                    }
                },
                tempoSeconde: 4
            });
        }
    }
    this.deleteDefinitivement = function (idTable, id, silencieux, funcOk) {
        if (typeof silencieux == "undefined" || silencieux == null) silencieux = false
        var nomTable = this.table.mGetItem(idTable).nom
        Me.mAjaxCall({ command: 'deletedefinitivementfromhistorique', nomtable: nomTable, id: id },
            function (data) {
                if (!silencieux) mNotify("L'élément a été définitivement supprimé de la corbeille.", "success", 6000);
                if (typeof funcOk != 'undefined') funcOk()
            }, null, function (data) {
                if (!silencieux) mNotify("Impossible de supprimer définitivement l'élément", "warning", 6000);
            })
    }

    this.getObjets = function () { return new cObjets(Me) }

    this.isAuthentified = function () {
        return (Me.utiCnx != null && Me.utiCnx.isAuthentified)
    }

    //variable initialisé dans le aspx
    this.mAjaxCall = function (dataToBeSent, funcOk, funcAlways, funcKo, showErreur) {
        dataToBeSent.urlAjax = "/ext/handlerexterne.ashx"
        //debugger;
        if (Me.utiCnx != null && Me.utiCnx.isAuthentified) dataToBeSent.urlAjax = "/handler/handlerinterne.ashx"
        if (typeof dataToBeSent.nom_base == 'undefined') dataToBeSent.nom_base = this.nom_base
        var ar = new cAjaxRequest(dataToBeSent, Me, funcOk, funcAlways, funcKo, showErreur)
        return ar.execute()
    }

    this.mAjaxCallAsync = function (dataToBeSent, funcOk, funcAlways, funcKo, showErreur) {
        var self = this
        return new Promise(function (resolve, reject) {
            self.mAjaxCall(
                dataToBeSent,
                function (result) {
                    if (funcOk) funcOk.apply(this, arguments)
                    resolve(result)
                },
                function () {
                    if (funcAlways) funcAlways.apply(this, arguments)
                },
                function (erreur) {
                    if (funcKo) funcKo.apply(this, arguments)
                    reject(erreur)
                },
                showErreur
            )
        })
    }

    this.mReloadAllTable = function (funcOk) {
        var dataToBeSent = { command: "reloadbdd" }
        Me.mAjaxCall(dataToBeSent, function (data) {
            if (typeof funcOk != 'undefined') funcOk()
            Me.vue_table.forEach(function (table) {
                if (Me.hasStore(table.nom)) {
                    switch (table.nom) {
                        case "reservation":
                        case "reservation_hebergement":
                        case "reservation_arrhes":
                        case "reservation_commande":
                        case "hebergement_agenda_centrale_rdv":
                        case "centrale_reservation":
                        case "centrale_reservation_fermeture":
                        case "centrale_reservation_fermeture_hebergement":
                            Me.triggerFunctionOnModifiedItemData(table.nom, "modif")
                    }
                }
            })
        })
    }
    this.mReloadTable = function (nomTableToReload, funcOk) {
        var tab = ""
        if ($.isArray(nomTableToReload)) {
            nomTableToReload.forEach(function (table) { tab += ((tab.length > 0) ? "," : "") + table })
        } else {
            tab = nomTableToReload
        }
        var dataToBeSent = { command: "reloadbdd", nom_table: tab }
        Me.mAjaxCall(dataToBeSent, function (data) {
            tab.split(",").forEach(function (nomTable) {
                switch (nomTable) {
                    case "reservation":
                    case "reservation_hebergement":
                    case "reservation_arrhes":
                    case "reservation_commande":
                    case "hebergement_agenda_centrale_rdv":
                    case "centrale_reservation_fermeture":
                    case "centrale_reservation_fermeture_hebergement":
                        Me.triggerFunctionOnModifiedItemData(nomTable, "modif")
                }
            })
            if (typeof funcOk != 'undefined') funcOk()
        })
    }
    this.mReloadItem = function (itemData, funcOk) {
        var obj = Me.getObjet(itemData)
        var dataToBeSent = { command: "reloadbdd", nom_table: obj.mGetTable().nom, id: obj.cle() }
        Me.mAjaxCall(dataToBeSent, function (data) {
            if (typeof funcOk != 'undefined') funcOk()
        })
    }
    ////objet ou l'on sauve des données calculés
    ////cet objet est vidé à chaque modification de la base
    //this.mClearPersistance = function () { mClearPersistance() }
    //function mClearPersistance() {
    //    tempsLoadMs = 0
    //    console.log("")
    //    delete Me.persistance
    //    for (var table in storeData) {
    //        storeData[table]._array.forEach(function (data) {
    //            for (var prop in data) {
    //                if (prop.startsWith("_")) delete data[prop];
    //            }
    //        })
    //    }
    //    if (typeof Me.onClearPersistance != 'undefined') Me.onClearPersistance()
    //}

    function mExecuteListOfFunction(objLstFunc, tempo, a, b, c, d, e, f) {

        var nbFonc = 0
        for (var prop in funcOnModifiedItemData) {
            nbFonc += funcOnModifiedItemData[prop].lstFunc.length
        }
        console.log("nbre fonction MODIFIEDITEMDATA:" + nbFonc)

        if (datMajSystem) console.log("deb calcul " + objLstFunc.nom + ": " + diffdate(datMajSystem, new Date(), "ms") + "ms - " + diffdate(datMajSystem, new Date(), "s") / 1000 + "s")
        var totTemps = ""
        if (typeof tempo == 'undefined' || tempo == null) tempo = 0
        window.clearTimeout(objLstFunc.timeOutModifGeneral);
        window.clearTimeout(objLstFunc.timeOutModifExeFunc);
        var timeOut = null
        var lstFunc = []
        timeOut = window.setTimeout(function () {

            if (datMajSystem) console.log("deb timeOUT " + objLstFunc.nom + ": " + diffdate(datMajSystem, new Date(), "ms") + "ms - " + diffdate(datMajSystem, new Date(), "s") / 1000 + "s")
            objLstFunc.lstFunc.forEach(function (f) { lstFunc.push(f); })
            mExecuteFunction(0)

            if (datMajSystem) console.log("fin timeOUT " + objLstFunc.nom + ": " + diffdate(datMajSystem, new Date(), "ms") + "ms - " + diffdate(datMajSystem, new Date(), "s") / 1000 + "s")
        }, tempo)
        function mExecuteFunction(idx) {
            if (typeof lstFunc[idx] != 'undefined') {
                var exe = lstFunc[idx].func(a, b, c, d, e, f)
                if (!exe) { objLstFunc.lstFunc.splice(objLstFunc.lstFunc.indexOf(lstFunc[idx]), 1); }
                idx += 1
                mExecuteFunction(idx)
            } else {
                if (datMajSystem) {
                    console.log("MAJ " + objLstFunc.nom + ": " + diffdate(datMajSystem, new Date(), "ms") + "ms - " + diffdate(datMajSystem, new Date(), "s") / 1000 + "s")
                }
                console.log("NBRE FONCTION MAJ: " + idx)
            }
        }
    }

    this.mDelData = function (id_table, id, funcOk) {
        var table = this.table.mGetItem(id_table)
        var dataObjet = {}
        dataObjet['id_' + table.nom] = id
        Me.mAjaxCall({ command: "deletedefinitivement", nomtable: table.nom, objet: dataObjet }, function (data) {
            if (typeof funcOk != 'undefined') funcOk(data)
        })
    }

    this.mGetLstDptPromise = function () {
        var deferred = $.Deferred();
        Me.mAjaxCall({
            command: "getlstdpt"
        }, function (data) {
            debugger;
            parametre.lst_dpt = JSON.parse(data.lst_dpt_string)
            deferred.resolve(JSON.parse(data.lst_dpt_string));
        }, null, function (data) {
            deferred.resolve(JSON.parse(JSON.stringify(parametre.lst_dpt)))
        })

        return deferred.promise();
    }

    this.mGetLstRegionPromise = function () {
        var deferred = $.Deferred();
        Me.mAjaxCall({
            command: "getlstregion"
        }, function (data) {
            debugger;
            parametre.lst_region = JSON.parse(data.lst_region_string)
            deferred.resolve(JSON.parse(data.lst_region_string));
        }, null, function (data) {
            deferred.resolve(JSON.parse(JSON.stringify(parametre.lst_region)))
        })

        return deferred.promise();
    }

    this.mGetLstPaysPromise = function () {
        var deferred = $.Deferred();
        Me.mAjaxCall({
            command: "getlstpays"
        }, function (data) {
            debugger;
            parametre.lst_pays = JSON.parse(data.lst_pays_string)
            deferred.resolve(JSON.parse(data.lst_pays_string));
        }, null, function (data) {
            deferred.resolve(JSON.parse(JSON.stringify(parametre.lst_pays)))
        })

        return deferred.promise();
    }

    this.mModifValueChamp = function (nomChamp, nomTable, lstId, value, funcFin) {
        Me.mAjaxCall({
            command: "updatetablechamp",
            nom_champ: nomChamp,
            nom_table: nomTable,
            lst_id: lstId,
            value: value
        }, function () {
            if (funcFin) funcFin()
        })
    }

    this.mGetLibelleMenuBulk = function () {
        var lib = ""
        if (Me.objCptCli.objetMetier.hasNote()) {
            lib += (lib.length > 0 ? ", " : "") + "Notes"
        }
        if (Me.objCptCli.objetMetier.hasPipeline()) {
            lib += (lib.length > 0 ? ", " : "") + "Pipelines"
        }
        if (Me.objCptCli.objetMetier.hasEmail()) {
            lib += (lib.length > 0 ? ", " : "") + "eMailings"
        }
        if (Me.objCptCli.objetMetier.hasSondage()) {
            lib += (lib.length > 0 ? ", " : "") + "Sondages"
        }
        if (Me.objCptCli.objetMetier.hasCourrier()) {
            lib += (lib.length > 0 ? ", " : "") + "Courriers"
        }
        if (Me.objCptCli.objetMetier.hasSms()) {
            lib += (lib.length > 0 ? ", " : "") + "SMS"
        }
        if (parametre.code_appli == "ppmasc") {
            lib += (lib.length > 0 ? ", " : "") + "Formulaires"
        }
        return lib
    }

}
window.tempsLoadMs = 0